import { render } from "./CodeReviewFixBatch.vue?vue&type=template&id=076aaace&scoped=true"
import script from "./CodeReviewFixBatch.vue?vue&type=script&lang=js"
export * from "./CodeReviewFixBatch.vue?vue&type=script&lang=js"

import "./codeReview.css?vue&type=style&index=0&id=076aaace&scoped=true&lang=css&external"
import "./CodeReviewFixBatch.vue?vue&type=style&index=1&id=076aaace&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076aaace"]])

export default __exports__